import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deletePurchase, getPurchaseByDate } from '../../../action';
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import { toast, ToastContainer } from 'react-toastify';
import './purchasedetail.css'
import ReactPaginate from 'react-paginate'
import Loading from '../../../util/Loading';

export default function PurchaseDashboard() {
    TabTitle("Purchase Dashboard");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const [purchaseData, setPurchaseData] = useState([])
    const [purchases] = state.purchaseAPI.purchases;

    //Import state
    const [rowPerPage] = state.purchaseAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.purchaseAPI.pageNumber;
    const [totalPages] = state.purchaseAPI.totalPages;
    const [setSearch] = state.purchaseAPI.search;
    const [callback, setCallback] = state.purchaseAPI.callback;

    //Local value states
    let gotDate = new Date();
    let defaultDate = new Date(gotDate).toISOString().slice(0, 10)
    const [startDate, setStartDate] = useState(defaultDate)
    const [endDate, setEndDate] = useState(defaultDate);
    const [trigger, setTrigger] = useState(false)

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const searchByDateHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);

        setTimeout(() => {
            setTrigger(true);
        }, 1000);

        e.target.name === "start_date" ? setStartDate(e.target.value) : setEndDate(e.target.value);
    }

    const onChangeSearchHandler = (start_date, end_date) => {
        getPurchaseByDate(rowPerPage, pageNumber, start_date, end_date, res => {
            setPurchaseData(res);
            setPageNumber(res.totalPages ? res.totalPages : 1)
        })
    }

    const deletePurchaseHandler = (id) => {
        deletePurchase(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }

    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    useEffect(() => {
        setPurchaseData(purchases);
        if (trigger) {
            onChangeSearchHandler(startDate, endDate);
            setTrigger(false);
        }
    }, [rowPerPage, pageNumber, purchases, trigger])

    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header custom-flex">
                    <p>Purchase Details</p>
                    <div className='custom-search'>
                        <input
                            type="date"
                            name="start_date"
                            id="start_date"
                            value={startDate}
                            onChange={(e) => searchByDateHandler(e)}
                        />

                        <input
                            type="date"
                            name="end_date"
                            id="end_date"
                            value={endDate}
                            onChange={(e) => searchByDateHandler(e)}
                        />

                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search purchase here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to='/purchase-form'><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    purchaseData.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Invoice No</th>
                                        <th>Qty</th>
                                        <th>Total Amount</th>
                                        <th>Purchase Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        purchaseData.count > 0 ? purchaseData.data.map(purchase => (
                                            <tr key={purchase.id}>
                                                <td>{purchase.invoice_no}</td>
                                                <td>{purchase.quantity}</td>
                                                <td>{purchase.total_amount}</td>
                                                <td>{dateConverter(purchase.purchase_date)}</td>
                                                <td>
                                                    <Link to={`/purchase-form/${purchase.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    <Link to={`/purchase-view/${purchase.id}`}><button><i className="uil uil-eye"></i></button></Link>
                                                    <button onClick={() => deletePurchaseHandler(purchase.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan={5}>Can not found any purchase details.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}